import { Box, Grid, Paper, Typography } from "@mui/material";
import { formatMoney, num, plColor } from "./plConstants";

const Card = ({ label, value, color, subtitle }) => (
  <Paper elevation={1} sx={{ p: 2, height: "100%", borderRadius: 2 }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ textTransform: "uppercase", letterSpacing: 0.5 }}
    >
      {label}
    </Typography>
    <Typography variant="h6" sx={{ fontWeight: 700, color: color || "text.primary", mt: 0.5 }}>
      {value}
    </Typography>
    {subtitle != null && (
      <Typography variant="caption" color="text.secondary">
        {subtitle}
      </Typography>
    )}
  </Paper>
);

// Filter-reactive grand totals.
const SummaryCards = ({ summary }) => {
  const s = summary || {};
  const cards = [
    {
      label: "Net Profit / Loss",
      value: formatMoney(s.netProfitLoss),
      color: plColor(s.netProfitLoss),
    },
    { label: "Total Agreed", value: formatMoney(s.totalAgreed) },
    { label: "Total Cost", value: formatMoney(s.totalCost) },
    { label: "Total Paid", value: formatMoney(s.totalPaid) },
    {
      label: "Total Due",
      value: formatMoney(s.totalDue),
      color: num(s.totalDue) > 0 ? "warning.main" : "text.primary",
    },
  ];

  return (
    <Box sx={{ mb: 2 }}>
      <Grid container spacing={2}>
        {cards.map((c) => (
          <Grid item xs={12} sm={6} md={2.4} key={c.label}>
            <Card {...c} />
          </Grid>
        ))}
      </Grid>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
        {num(s.entryCount)} entries across {num(s.clientCount)} clients
        {num(s.totalReferral) ? ` · Referral ${formatMoney(s.totalReferral)}` : ""}
        {num(s.totalCommission) ? ` · Commission ${formatMoney(s.totalCommission)}` : ""}
      </Typography>
    </Box>
  );
};

export default SummaryCards;
